import { inPlaceSort } from 'fast-sort';
import { LabelCreatable } from '../../../../components/Input/Input';
import { FaTrashCan } from 'react-icons/fa6';
import { useEffect, useState } from 'react';
import { supabase } from '../../../../supabaseClient';
import { alertSuccess } from '../../../../components/Toast';

export const useFormOfPayment = ({
  onChange,
  setValues,
  setHasCreated,
  setReloadPrint,
  values,
  setOldValues,
  company,
  reloadPaymentOptions,
}) => {
  const [menuOpen, setMenuOpen] = useState();
  const [paymentOptions, setPaymentOptions] = useState([]);

  const divCreatable = (data, e) => {
    if (data.id) {
      e.preventDefault();
      onChange('payment', { label: data.label, value: data.id });
    } else {
      setValues((values) => ({
        ...values,
        payment: { label: data.value, value: '0' },
      }));
      setHasCreated((hasCreated) => !hasCreated);
    }
    setReloadPrint((reload) => !reload);
    e.type === 'click' ? setMenuOpen(false) : null;
  };

  const deleteOptions = async (id, e) => {
    e.preventDefault();
    e.stopPropagation();

    const { data, error } = await supabase
      .from('PaymentTypes')
      .update({ deleted_at: new Date() })
      .eq('id', id);

    if (!error) {
      setPaymentOptions(
        paymentOptions.filter((options) => options.id !== parseInt(id))
      );
      alertSuccess('Deletado com sucesso');
    }
  };

  useEffect(() => {
    loadPaymentTypes();
  }, [company.id, reloadPaymentOptions]);

  const loadPaymentTypes = async () => {
    let { data, error } = await supabase
      .from('PaymentTypes')
      .select('*')
      .eq('id_company', company.id)
      .is('deleted_at', null);

    if (!error) {
      setPaymentOptions(
        data.map((item) => ({ ...item, label: item.title, value: item.id }))
      );
    }
  };

  useEffect(() => {
    if (
      paymentOptions.length > 0 &&
      values?.payment &&
      !values?.payment?.value
    ) {
      setValues((old) => ({
        ...old,
        payment: paymentOptions?.find(
          (payment) => payment.label === old.payment
        )
          ? paymentOptions?.find((payment) => payment.value === old.payment)
          : { label: old.payment, value: old.payment },
      }));
      setOldValues((old) => ({
        ...old,
        payment: paymentOptions?.find(
          (payment) => payment.label === old.payment
        )
          ? paymentOptions?.find((payment) => payment.value === old.payment)
          : { label: old.payment, value: old.payment },
      }));
    }
  }, [values?.payment, paymentOptions]);

  const OptionFunc = (props) => {
    const { data } = props;
    return (
      <div
        {...props}
        className="deletable-creatable"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '40px',
          padding: '10px',
        }}
      >
        <div
          onClick={(e) => divCreatable(data, e)}
          style={{
            textTransform: 'uppercase',
            width: '100%',
            height: '40px',
            alignContent: 'center',
          }}
        >
          {data?.label}
        </div>
        <div>
          <FaTrashCan
            style={{ color: 'rgb(255 130 120)' }}
            onClick={(e) => deleteOptions(data.id, e)}
          />
        </div>
      </div>
    );
  };

  const sortedPaymentOptions = paymentOptions.map((item) => ({
    value: item.payment_type.value,
    label: item.payment_type.label,
    id: item.id,
  }));

  inPlaceSort(sortedPaymentOptions).asc([
    (item) => item.label.replace(/[^a-zA-Z]/g, '').toLowerCase(),
    (item) => {
      const numberMatch = item.label.match(/\d+/);
      return numberMatch ? parseInt(numberMatch[0], 10) : 0;
    },
  ]);

  const createOption = async (name, field) => {
    setReloadPrint((reload) => !reload);
    setValues((values) => ({
      ...values,
      [field]: { label: name, value: '0' },
    }));

    setHasCreated((prev) => !prev);
  };

  const creatableOpen = (e) => {
    if (e.target.id === 'react-select-6-input') {
      setMenuOpen(true);
    } else if (e.target.id === 'path') {
      setMenuOpen(true);
    }
  };

  const InputFormOfPayment = () => (
    <div className="payment-dropdown">
      <div onClick={(e) => creatableOpen(e)} className="void-class">
        <LabelCreatable
          // menuIsOpen={menuOpen}
          onCreateOption={(name) => createOption(name, 'payment')}
          components={{ Option: (props) => OptionFunc(props) }}
          options={inPlaceSort(sortedPaymentOptions).asc([
            (item) => item.label.replace(/[^a-zA-Z]/g, '').toLowerCase(),
            (item) => {
              const numberMatch = item.label.match(/\d+/);
              return numberMatch ? parseInt(numberMatch[0], 10) : 0;
            },
          ])}
          defaultValue={values?.payment}
          onChange={(value) => onChange('payment', value)}
          placeholder={'INSIRA A FORMA DE PAGAMENTO'}
          label={'Forma de pagamento'}
          className="generic-input select-creatable budget-percentage-input budget-creatable"
          styles={{
            option: (base) => ({
              ...base,
              border: ``,
              height: '100%',
            }),
          }}
        />
      </div>
    </div>
  );
  return { InputFormOfPayment };
};
